import React, { useEffect, useState } from 'react';
import { Phone } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

export default function StickyPhoneButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Show after user scrolls past roughly the hero height (~100vh)
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.85);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="fixed bottom-5 left-0 right-0 z-50 md:hidden flex justify-center px-5"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 16 }}
          transition={{ duration: 0.35 }}
        >
          <a
            href="tel:2812037688"
            className="flex items-center justify-center gap-3 bg-[#1B2A4A] text-white py-4 rounded-full shadow-2xl font-body font-bold text-sm uppercase tracking-wider w-full"
            style={{ boxShadow: '0 0 18px 4px rgba(27,42,74,0.85), 0 4px 24px rgba(0,0,0,0.5)' }}
          >
            <Phone className="w-4 h-4" />
            Call Justin — (281) 203-7688
          </a>
        </motion.div>
      )}
    </AnimatePresence>
  );
}